import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Input } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import { useUserContext } from '../../context/user_context';
import { toast } from 'react-toastify';

const WhatsappPopup = ({ setIsOpenWhatsapp, productId, username }) => {
  const menuRef = useRef(null);
  const { currentUser } = useUserContext();
  const [whatsappNumber, setWhatsappNumber] = useState(null);
  const handleSubmit = async () => {
      let res = await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}/api/whatsapp-queries/new`,
        {
          productId: productId,
          username: currentUser ? currentUser.username : '',
          whatsappNumber: whatsappNumber,
          email: currentUser ? currentUser.email : '',
        }
      );
      if (res.data.status == 200) {
        toast.success('Request sent');
      } else {
        toast.error('invalid data');
      }
    setIsOpenWhatsapp(false);
  };
  return (
    <div className='fixed inset-0 bg-[rgba(0,0,0,0.5)] bg-opacity-40 flex items-center justify-center z-50 p-3'>
      <div className='bg-white w-full max-w-md rounded-xl shadow-lg p-6 relative animate-fadeIn'>
        <div className='space-y-4'>
          <div>
            <label className='block text-sm font-medium text-gray-600 mb-1'>
              Whatsapp number
            </label>
            <Input
              type={'number'}
              label={''}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              value={whatsappNumber}
              placeholder={'Enter whatsapp number'}
              className='text-black'
            />
          </div>
        </div>

        {/* Buttons */}
        <div className='flex justify-end gap-3 mt-6'>
          <button
            className='bg-[#D3A143] text-white rounded-md p-2 mr-2'
            onClick={() => {
              setIsOpenWhatsapp(false);
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className='rounded-md bg-blue-950 px-2 text-white'
          >
           Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsappPopup;
